import { render } from "./rzDialog.vue?vue&type=template&id=4e611624&scoped=true"
import script from "./rzDialog.vue?vue&type=script&lang=js"
export * from "./rzDialog.vue?vue&type=script&lang=js"

import "./rzDialog.vue?vue&type=style&index=0&id=4e611624&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e611624"]])

export default __exports__